// @flow
import * as React from 'react';
import styled from 'styled-components';
import { useDropzone } from 'react-dropzone';
import { faCloudUploadAlt, faSpinner } from '@fortawesome/free-solid-svg-icons';
import ButtonSecondary from '@components/ButtonSecondary';

import {
  StyledUpload,
  StyledUploadParagraph,
  StyledFontAwesomeIcon,
  StyledUploadSpan
} from './styles';
import type { Props } from './types';

const ButtonSecondaryInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const UploadNew = ({
  pending,
  buttonLabel,
  uploadLabel,
  isModal,
  onLoad,
  treatmentFormName
}: Props): React.Node => {
  const onDrop = acceptedFiles =>
    acceptedFiles.forEach((file, index) => {
      const reader = new FileReader();
      reader.onload = () => onLoad(reader, file, index);
      reader.readAsDataURL(file);
    });

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <StyledUpload {...getRootProps()}>
      <StyledFontAwesomeIcon
        icon={pending ? faSpinner : faCloudUploadAlt}
        spin={pending}
        className={isDragActive && 'active'}
        isModal={isModal}
      />
      <StyledUploadParagraph treatmentFormName={treatmentFormName} isModal={isModal}>
        {uploadLabel}
      </StyledUploadParagraph>
      <StyledUploadSpan treatmentFormName={treatmentFormName} isModal={isModal}>
        Browse on your device
      </StyledUploadSpan>
      <ButtonSecondary size="LARGE" inverted>
        <ButtonSecondaryInner>
          <input {...getInputProps()} />
          {buttonLabel}
        </ButtonSecondaryInner>
      </ButtonSecondary>
    </StyledUpload>
  );
};

export default UploadNew;
